/**
 * Turns level objects into supply boxes which you can grab items from.
 */
export function InfiniteSupply(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
        }
        grab(_filter) {
            if (!this.foodType) {
                return null;
            }
            const grabbed = new this.foodType(this.levelMap, this.position);
            this.levelMap.world.add(grabbed);
            return grabbed;
        }
        getProperties() {
            return Object.assign(Object.assign({}, super.getProperties()), { contents: this.foodType.type });
        }
    };
}
